// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@keyframes circular-animation-60469e28{to{stroke-dashoffset:0}}.comparison-button[data-v-60469e28]{width:min(260px,85%)}@media(max-width:570px){.comparison-button[data-v-60469e28]{width:min(130px,85%)}}.comparison-button[data-v-60469e28]:not(.disabled):hover{color:#00b19f!important}.comparison-button .title[data-v-60469e28]{white-space:nowrap}.disabled[data-v-60469e28]{color:#7d7d7d!important}.product-added[data-v-60469e28]{color:#00b19f!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
